import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createTemplate, updateTemplate, linkTemplateToContractType, unlinkTemplateFromContractType} from './api'
import {BaseTemplateData, TemplateResponseData} from './api'
import {templateKeys} from './keys'

export const useCreateTemplate = () => {
  const queryClient = useQueryClient()
  return useMutation<TemplateResponseData, unknown, BaseTemplateData>({
    mutationFn: createTemplate,
    onSuccess: () => queryClient.invalidateQueries({queryKey: templateKeys.lists()}),
  })
}

export const useUpdateTemplate = () => {
  const queryClient = useQueryClient()
  return useMutation<TemplateResponseData, unknown, {id: string; body: BaseTemplateData}>({
    mutationFn: ({id, body}) => updateTemplate(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: templateKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: templateKeys.lists()})
    },
  })
}

export const useLinkTemplateToContractType = () => {
  const queryClient = useQueryClient()
  return useMutation<void, unknown, {templateId: string; contractTypeId: string}>({
    mutationFn: ({templateId, contractTypeId}) => linkTemplateToContractType(templateId, contractTypeId),
    onSuccess: () => queryClient.invalidateQueries({queryKey: templateKeys.lists()}),
  })
}

export const useUnlinkTemplateFromContractType = () => {
  const queryClient = useQueryClient()
  return useMutation<void, unknown, {templateId: string; contractTypeId: string}>({
    mutationFn: ({templateId, contractTypeId}) => unlinkTemplateFromContractType(templateId, contractTypeId),
    onSuccess: () => queryClient.invalidateQueries({queryKey: templateKeys.lists()}),
  })
}
